import type { Types } from '@fiverr-private/theme';
import type { TabContextType } from '../types';

export const getStylingProps = (variant?: TabContextType['variant']): Types.ContainerProps => ({
    ...(variant !== 'unstyled' && {
        padding: '2',
    }),
});
